import React, { useState, useEffect } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import {  Box, Stack } from '@mui/material';
import { format, parse, isValid } from 'date-fns';
import { es } from 'date-fns/locale'; 

import { esES } from '@mui/x-date-pickers/locales';

const DateRangeFilter = ({ onDateRangeChange, value = {} }) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [error, setError] = useState('');

  const parseDate = (value) => {
    if (!value) return null;
    const parsedDate = parse(value, 'dd/MM/yyyy', new Date());
    return isValid(parsedDate) ? parsedDate : null;
  };

const handleStartDateChange = (date) => {
  let newDate = date;
  
  if (typeof date === 'string') {
    newDate = parseDate(date);
  }
  
  if (newDate && !isValid(newDate)) {
    setStartDate(null);
    return;
  }
  
  setStartDate(newDate);
  
  if (endDate && newDate && newDate > endDate) {
    setError('La fecha de inicio no puede ser mayor que la fecha final');
  } else {
    setError('');
    if (newDate && endDate) {
      onDateRangeChange({
        startDate: format(newDate, 'yyyy-MM-dd'),
        endDate: format(endDate, 'yyyy-MM-dd')
      });
    }
  }
};

const handleEndDateChange = (date) => {
  let newDate = date;
  
  if (typeof date === 'string') {
    newDate = parseDate(date);
  }
  
  if (newDate && !isValid(newDate)) {
    setEndDate(null);
    return;
  }
  
  setEndDate(newDate);
  
  if (startDate && newDate && newDate < startDate) {
    setError('La fecha final no puede ser menor que la fecha de inicio');
  } else {
    setError('');
    if (startDate && newDate) {
      onDateRangeChange({
        startDate: format(startDate, 'yyyy-MM-dd'),
        endDate: format(newDate, 'yyyy-MM-dd')
      });
    }
  }
};

const sharedDateFieldSx = {
  '& .MuiOutlinedInput-root': {
    height: 40,
    borderRadius: 2,
    color: '#333',
    '& fieldset': {
      border: '1px solid #D1D5DB !important',
    },
    '&:hover fieldset': {
      border: '1px solid #D1D5DB !important',
    },
    '&.Mui-focused fieldset': {
      border: '1px solid #D1D5DB !important',
      boxShadow: 'none',
      outline: 'none',
    },
  },
  '& .MuiInputLabel-root': {
    fontSize: '0.875rem',
    '&.Mui-focused': {
      color: '#000',
    },
  },
  '& .MuiInputBase-input': {
    padding: '10px 14px',
    fontSize: '0.875rem',
    color: '#000',
  },
};

useEffect(() => {
  if (value.startDate) {
    setStartDate(parse(value.startDate, 'yyyy-MM-dd', new Date()));
  } else {
    setStartDate(null);
  }
  
  if (value.endDate) {
    setEndDate(parse(value.endDate, 'yyyy-MM-dd', new Date()));
  } else {
    setEndDate(null);
  }
}, [value.startDate, value.endDate]);

  return (
    <LocalizationProvider 
      dateAdapter={AdapterDateFns}
      adapterLocale={es}
      localeText={esES.components.MuiLocalizationProvider.defaultProps.localeText}>
      <Box 
        sx={{ mt: 0.5 }}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()} 
        > 
        <Stack direction={{ xs: 'column', sm: 'row' }}  spacing={2}>
            <DatePicker
            label="Inicio"
            value={startDate}
            onChange={handleStartDateChange}
            maxDate={endDate || undefined}
            inputFormat="dd/MM/yyyy"
            mask="__/__/____"
            slotProps={{
                textField: {
                fullWidth: true,
                size: 'small',
                color: 'inherit', 
                sx: sharedDateFieldSx,
                onClick: (e) => e.stopPropagation(), 
                },
            }}
            />

            <DatePicker
            label="Fin"
            value={endDate}
            onChange={handleEndDateChange}
            minDate={startDate || undefined}
            slotProps={{
                textField: {
                fullWidth: true,
                size: 'small',
                color: 'inherit',
                sx: sharedDateFieldSx,
                onClick: (e) => e.stopPropagation(), 
                },
            }}
            />

        </Stack>
        {error && (
          <Box sx={{ color: 'error.main', fontSize: '0.75rem', mt: 1 }}>
            {error}
          </Box>
        )}
      </Box>
    </LocalizationProvider>
  );
};

export default DateRangeFilter;